import { createNormalizedSelector, createDenormalizedSelector } from 'entities/selectors'
import { reservationSchema } from 'grs/schemas'
import { pendingSelector } from 'api/selectors'
import { createSelector } from 'reselect'
import { createUserCreditCardInfoSelector } from 'auth/selectors'

const stateSelector = state => state.dashboardTransactions
const idSelector = (state, props) => props.reservationId || props.waitingListKey

export const reservationSelector = createDenormalizedSelector(idSelector, reservationSchema)

export const resultsStateSelector = createSelector(stateSelector, state => state.results)
export const resultsSelector = createSelector(resultsStateSelector, state => state.reservations)
export const areAllVisibleSelector = createSelector(resultsStateSelector, state => state.areAllVisible)
export const offsetSelector = createSelector(resultsSelector, results => results.length)
export const statusSelector = createSelector(stateSelector, state => state.status)

const denormalizedReservationsSelector = createDenormalizedSelector(resultsSelector, [reservationSchema])

export const dashboardReservationsWithStatusSelector = createSelector(
    denormalizedReservationsSelector,
    statusSelector,
    (reservations, status) => reservations.map(reservation => ({ ...reservation, reservationStatus: status }))
)

const sortedDashboardReservationsSelector = createSelector(denormalizedReservationsSelector, reservations =>
    reservations ? [...reservations].sort((a, b) => (a.createdDate.isAfter(b.createdDate) ? -1 : 1)) : []
)

export const dashboardReservationsSelector = createNormalizedSelector(sortedDashboardReservationsSelector, [
    reservationSchema,
])

export const cancellationSelector = state => state.reservationCancelling

export const cancellationAmountsSelector = createSelector(cancellationSelector, state => {
    const { cancellationFee, refundAmount, currencySymbol } = state
    return { cancellationFee, refundAmount, currencySymbol }
})

export const selectedReservationSelector = createSelector(stateSelector, state => state.selectedReservationId)

export const changeVehiclePendingSelector = createSelector(pendingSelector, pending => pending.changeVehicle)

export const cancelWaitingListRecordPendingSelector = createSelector(
    pendingSelector,
    idSelector,
    (pending, reservationId) => !!pending[`cancelWaitingList-${reservationId}`]
)

export const reservationWithStatusSelector = createSelector(
    reservationSelector,
    statusSelector,
    (reservation, status) => ({
        ...reservation,
        reservationStatus: status,
    })
)

const reservationCreditCardSelector = createSelector(reservationSelector, reservation => reservation.cardId)

export const reservationCreditCardInfoSelector = createUserCreditCardInfoSelector(reservationCreditCardSelector)
